import {Component, Input, OnInit} from '@angular/core';
import {Operation} from '../../../operation/operations/operation.model';
import {OperationUtils} from '../../utils/OperationUtils';
import {ConfigLoaderService} from '../../../app-loader/config-loader.service';
import {PlatformConfig} from '../../../app-loader/platform-config';

@Component({
  selector: 'app-print-operation',
  templateUrl: './print-operation.component.html',
  styleUrls: ['./print-operation.component.scss']
})
export class PrintOperationComponent implements OnInit {

  @Input('operation') operation: Operation;

  platformConfig: PlatformConfig;

  constructor(public configLoaderService: ConfigLoaderService) {
    this.platformConfig = this.configLoaderService.getPlatformConfig();
  }

  ngOnInit() {
  }


  isAmountCredited() {
    return OperationUtils.isOperationAmountCredited(this.operation);
  }

  isAmountDebited() {
    return OperationUtils.isOperationAmountDebited(this.operation);
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/print-operation/print-operation.component.ts